<div [class.miq2-0-table]="isLandingPageEnabled">
<div class="table-header-row" [ngClass]="{ downloadReportTable: isDownloadReportList() }">
  <span class="table-title">
    {{ (title() | uppercase) + ('shared.list' | translate) }}
    <span class="record-compare-sub-header">
      <span class="result-num">{{ totalRecords }}</span>
      <span class="results">
        {{ totalRecords === 1 ? ('recordsSearch.result' | translate) : ('recordsSearch.results' | translate) }}</span
        >
      </span>
    </span>
    @if (commands() && !isDownloadReportList()) {
      <span class="toolbar flt-right">
        <miq-commands [resources]="selectedResources" [commands]="commands()" (rowChange)="rowChange.emit()"></miq-commands>
      </span>
    }
  </div>

  <p-table
    [columns]="columns()"
    [value]="elements"
    [paginator]="false"
    [rows]="selectedRowsPerPage"
    [totalRecords]="elements.length"
    paginatorDropdownAppendTo="body"
    [rowsPerPageOptions]="[10, 15, 20]"
    [(selection)]="selectedResources"
    [customSort]="true"
    [resetPageOnSort]="false"
    (sortFunction)="sort($event)"
    [sortField]="defaultSorting"
    [dataKey]="dataKey()"
    selectionMode="multiple"
    (selectionChange)="onSelectionChange($event)"
    >
    <ng-template templeate pTemplate="header" let-columns>
      <tr>
        @for (col of columns;  track col) {
          <th
            scope="col"
            [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="!col.sortable"
            [style.width]="col.width"
            >
            {{ col.header | translate| titlecase }}
            @if (col.sortable) {
              <p-sortIcon [field]="col.field"></p-sortIcon>
            }
            @if (col.checkbox) {
              <miq-tableHeaderCheckbox></miq-tableHeaderCheckbox>
            }
          </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <ng-container>
        <tr
          miq-tree-data-row
          [row]="rowData"
          [columns]="columns"
          (toggle)="toggle($event)"
          (rowChange)="rowChange.emit($event)"
        ></tr>
      </ng-container>
    </ng-template>

    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length + 1">
          {{
          ('shared.no' | translate| titlecase) +
          (title() || 'elements' | titlecase) +
          ('shared.found' | translate| titlecase)
          }}
        </td>
      </tr>
    </ng-template>
  </p-table>
  <miq-table-paginator
    #paginator
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    [length]="elements.length"
    [pageIndex]="pageIndex"
    (pageChange)="handlePagination($event)"
    (pageSizeChange)="handlePageSizeChange($event)"
    >
  </miq-table-paginator>
</div>